import accessToken from "../../helpers/accessToken";
import router from "../../router/index";
import Mixins from "../../mixins/GlobalMixins";
import API_URL from "../../helpers/apiUrls";
import methods from "../../helpers/methods";

const state = {
  isSuperAdmin: false,
  superAdminId:'',
  masterLoader: false,
  user: {
    isLoggedIn: false,
    name: "",
    avatar: null,
    email: "",
    brand: {
      brandID: "",
      name: "",
      description: "",
      categoryID: null,
    },
  },
  temporaryAccessToken: null,
  temporaryRefreshToken: null,
  profileNavigationText: "",
  confirmationDialog: {
    dialog: false,
    content: "",
    action: null,
  },

  uploadedImages: [],
  imageUploadFailed: false,
};

const mutations = {
  SET_SUPER_ADMIN: (state, value) => {
    state.isSuperAdmin = value;
    if(value==true ){
      localStorage.setItem('Super-ID',localStorage.getItem('Brand-ID'))
     }
    //else{
    //   localStorage.setItem('Super-ID',localStorage.getItem('Brand-ID'))
    // }
   // console.log("mainstore", state, value);
  },
  SET_USER_DETAILS: (state, value) => {
    state.user = {
      isLoggedIn: true,
      name: value.name,
      avatar: value.avatar,
      brand: {
        brandID: value.brandID,
        name: value.brandName,
        description: "",
        categoryID: "",
      },
    };
    console.log("mainStore", state, value);
  },

  SET_CONFIRMATION_DIALOG: (state, value) => {
    state.confirmationDialog.dialog = true;
    state.confirmationDialog.content = value.content;
    state.confirmationDialog.action = value.action;
  },

  CLOSE_CONFIRMATION_DIALOG: (state) => {
    state.confirmationDialog.dialog = false;
    state.confirmationDialog.content = "";
    state.confirmationDialog.action = null;
  },

  SET_UPLOADED_IMAGES: (state, value) => {
    state.uploadedImages = [value, ...state.uploadedImages];
  },
};

const actions = {
  // LOG THE USER OUT
  logoutUser({ dispatch }, status) {
    accessToken.removeCredentials();
    router.push({ name: "login" });

    let color = "";
    let message = "";
    if (status === 470) {
      color = "error";
      message = "Your login session has been expired. Please re-login!";
      if (process.env.VUE_APP_MOENGAGE_ACTIVE !== "false") {
        window?.Moengage.destroy_session();
      }
    } else {
      color = "success";
      message = "You are successfully logged out!";
     
    }

    localStorage.clear()
    const snackBarData = {
      color: color,
      textMessage: message,
      timeOut: 5000,
    };

    dispatch("snackBar/setSnackBar", snackBarData, { root: true });
  },

  // TURN THE MASTER LOADER ON OR OFF
  toggleLoader({ state }, value) {
    state.masterLoader = value;
  },

  // SET THE RETRIEVE DETAILS OF THE USER
  setUserDetails({ commit }, data) {
    commit("SET_USER_DETAILS", data);
  },
  // Set the details of superadmin
  setSuperAdmin({ commit }, data) {
    commit("SET_SUPER_ADMIN", data);
  },
  // REFRESH TOKEN WHEN THE TOKEN IS EXPIRED AND RE-CALL THE API WHICH IS QUEUED.
  refreshToken({}, requestData) {
    const successHandler = (response) => {
      if (response.status === 200) {
        localStorage.setItem("accessToken", response.data.access);
        localStorage.setItem("refreshToken", response.data.refresh);

        requestData.headers.Authorization = `Bearer ${accessToken.getAccessToken()}`;

        switch (requestData.request) {
          case "GET":
            Mixins.methods.requestGET(
              requestData.url,
              requestData.params,
              requestData.headers,
              requestData.successResponse,
              requestData.errorResponse
            );
            break;
          case "POST":
            Mixins.methods.requestPOST(
              requestData.url,
              requestData.params,
              requestData.headers,
              requestData.successResponse,
              requestData.errorResponse
            );
            break;
          case "PUT":
            Mixins.methods.requestPUT(
              requestData.url,
              requestData.params,
              requestData.headers,
              requestData.successResponse,
              requestData.errorResponse
            );
            break;
          case "PATCH":
            Mixins.methods.requestPATCH(
              requestData.url,
              requestData.params,
              requestData.headers,
              requestData.successResponse,
              requestData.errorResponse
            );
            break;
          case "DELETE":
            Mixins.methods.requestDELETE(
              requestData.url,
              requestData.params,
              requestData.headers,
              requestData.successResponse,
              requestData.errorResponse
            );
            break;
          default:
            break;
        }
      }
    };

    const errorHandler = (error) => {
      console.log(error);
    };

    const data = {
      refresh: localStorage.getItem("refreshToken"),
    };

    Mixins.methods.requestPOST(
      API_URL.refreshAccessToken,
      data,
      {},
      successHandler,
      errorHandler
    );
  },

  // IMAGE UPLOAD
  imageUpload({ commit, state }, image) {
    state.imageUploadFailed = false;
    const successHandler = (response) => {
      commit("SET_UPLOADED_IMAGES", response.data);
    };

    const errorHandler = (error) => {
      state.imageUploadFailed = true;
      const snackBarData = {
        color: "error",
        textMessage: "Something went wrong internally!",
        timeOut: 10000,
      };
      dispatch("snackBar/setSnackBar", snackBarData, { root: true });
      console.log(error);
    };

    const data = new FormData();
    data.append("image", image);

    const headers = {
      Authorization: `Bearer ${accessToken.getAccessToken()}`,
    };

    Mixins.methods.requestPOST(
      API_URL.imageUpload,
      data,
      headers,
      successHandler,
      errorHandler
    );
  },
};

const getters = {
  GET_USER_DETAILS: (state) => state.user,

  GET_CONFIRMATION_DIALOG: (state) => state.confirmationDialog,

  GET_UPLOADED_IMAGES: (state) => state.uploadedImages,

  GET_IMAGE_UPLOAD_STATUS: (state) => state.imageUploadFailed,

  GET_SUPER_ADMIN: (state) => state.isSuperAdmin,

  GET_SUPER_ADMIN_ID:(state)=>state.superAdminId
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
